import RocketImage from 'assets/images/RocketImage';
import { NotFound } from 'shared/NotFound';

import { BtnReturn } from './Button';
import { Content } from './styles';

export const PageNotFound = () => {
  return (
    <Content>
      <NotFound title='Erro 404' subtitle='Não encontramos o que você estava procurando' />
      <RocketImage />
      <BtnReturn />
    </Content>
  );
};
